<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">

			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"
					@change="formatAmount(`${item.model}`)"></el-input>
			</el-form-item>

			<el-form-item label="原租客变更" prop="old_type"><br>
				<el-radio v-model="inputmodel.old_type" :label="1">变更为同住人</el-radio>
				<el-radio v-model="inputmodel.old_type" :label="2">变更为过往租客</el-radio>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>
<script>
	import {
		up_img,
		get_house,
		contract_change_tenant,
		house_list
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";

	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '姓名',
					model: 'name'
				}, {
					name: '手机号',
					model: 'phone'
				}, {
					name: '身份证号',
					model: 'card_id'
				}, ],
				inputmodel: {
					name: '',
					phone: '',
					card_id: '',
					old_type: 1
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 0,
					rent_status: 0
				},

				fwq: [], // 用于存储服务器返回的图片URL
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);

				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {

							const {
								name,
								phone,
								card_id,
								old_type,
							} = this.inputmodel
							const cid = this.inputmodel.id

							contract_change_tenant({
								name,
								phone,
								card_id,
								old_type,
								cid
							}).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				// this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				get_house(formData).then(res => {
					const _res = res.data
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			formatAmount(field) {
				if (this.inputmodel[field] !== undefined && typeof this.inputmodel[field] === 'number') {
					this.inputmodel[field] = parseFloat(this.inputmodel[field].toFixed(2));
				}
			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号
				const fieldsToUpdate = ['rent', 'deposit', 'property_fee'];

				// 查找对应的 item
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id;

					house_list({
						room_num: value
					}).then(res => {
						// 检查并更新 inputmodel 中的字段
						fieldsToUpdate.forEach(field => {
							const fieldValue = res.data.list[0][field];
							if (typeof fieldValue === 'number') {
								this.inputmodel[field] = parseFloat(fieldValue.toFixed(2));
							} else {
								this.inputmodel[field] = fieldValue; // 如果不是数字类型，则直接赋值
							}
						});
					});
				}
			},


		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			get_house().then(res => {
				const _res = res.data
				this.options = _res;
			})

			// 3. 安全地初始化 inputmodel 数据
			const item = this.item; // 接收父组件传来的 prop

			if (item) { // ✅ 防御：确保 item 存在
				['name', 'phone', 'card_id', 'id'].forEach(key => {
					this.inputmodel[key] = item[key] || '';
				});
			} else {
				console.warn('this.item is not provided');
				// 可选：设置默认空值
				this.inputmodel.name = '';
				this.inputmodel.phone = '';
				this.inputmodel.card_id = '';
			}

			// 4. 设置默认状态（数字 1）
			this.inputmodel.old_type = 1;
		},
		mounted() {

		},
		watch: {
			item(newVal) {
				// 定义要同步的字段
				const fields = ['name', 'phone', 'card_id', 'id'];

				fields.forEach(key => {
					this.inputmodel[key] = newVal[key] || '';
				});

				// 单独设置状态，默认为 1（数字）
				this.inputmodel.old_type = 1;
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>
<style>
	.el-upload-list__item {
		margin-top: 0px !important;
	}
</style>